import * as DATE from 'date-fns';
import { flow } from 'fp-ts/function';
export var formatRelativeDate = flow(DATE.parseISO, DATE.formatDistanceToNowStrict);